// extracted by mini-css-extract-plugin
module.exports = {"home":"_2XF5q2KyezICi-z34RCybG"};